import {Component, EventEmitter, Input, Output} from '@angular/core';
import {PER_PAGE} from './ref-utils';

@Component({
    selector: 'app-ref-pager',
    template: `
        <div class="ref-pager">
            <span>Showing {{total ? page * per + 1 : 0}}–{{min(total, page * per + per)}} of {{total}}</span>
            <span class="ref-tools">
                <button class="btn btn-outline-secondary btn-sm" type="button" [disabled]="page === 0"
                        (click)="pageChange.emit(page - 1)">Previous</button>
                <button class="btn btn-outline-secondary btn-sm" type="button" [disabled]="page >= pages - 1"
                        (click)="pageChange.emit(page + 1)">Next</button>
            </span>
        </div>`
})
export class RefPagerComponent {
    @Input() total = 0;
    @Input() page = 0;
    @Input() per = PER_PAGE;
    @Output() pageChange = new EventEmitter<number>();

    get pages(): number {
        return Math.max(1, Math.ceil(this.total / this.per));
    }

    min(a: number, b: number): number {
        return Math.min(a, b);
    }
}
